// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { AffiliationsState } from '../_reducers/affiliation.reducers';
import { Affiliation } from '../_models/affiliation.model';

export const selectAffiliationsState = createFeatureSelector<AffiliationsState>('affiliations');

export const selectAffiliationById = (affiliationId: number) =>
  createSelector(
    selectAffiliationsState,
    (affiliationsState) => affiliationsState.entities[affiliationId],
  );

export const selectAffiliationsPageLoading = createSelector(
  selectAffiliationsState,
  (affiliationsState) => {
    return affiliationsState.listLoading;
  },
);

export const selectAffiliationsActionLoading = createSelector(
  selectAffiliationsState,
  (affiliationsState) => affiliationsState.actionsloading,
);

export const selectLastCreatedAffiliationId = createSelector(
  selectAffiliationsState,
  (affiliationsState) => affiliationsState.lastCreatedAffiliationId,
);

export const selectAffiliationsPageLastQuery = createSelector(
  selectAffiliationsState,
  (affiliationsState) => affiliationsState.lastQuery,
);
export const selectErrorState = createSelector(
  selectAffiliationsState,
  (affiliationsState) => affiliationsState.error,
);
export const selectAffiliationsInStore = createSelector(
  selectAffiliationsState,
  (affiliationsState) => {
    const items = (affiliationsState.ids as number[])
      .map((id) => affiliationsState.entities[id])
      .filter((item): item is Affiliation => item !== undefined);
    return new QueryResultsModel(items, affiliationsState.totalCount);
  },
);

export const selectAffiliationsShowInitWaitingMessage = createSelector(
  selectAffiliationsState,
  (affiliationsState) => affiliationsState.showInitWaitingMessage,
);

export const selectHasAffiliationsInStore = createSelector(
  selectAffiliationsState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
